import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {TreatmentPlanningProcedurePseudoModel} from '../../modules/treatment-planning/models/treatment-planning-procedure-pseudo.model';
import {TreatmentPlanningProcedureDataModel} from '../../modules/treatment-planning/models/treatment-planning-procedure-data.model';
import {TreatmentPlanningFormDataModel} from '../../modules/treatment-planning/treatment-planning-form-data.model';

@Component({
  standalone: false,
  selector: 'app-forms-dialog',
  templateUrl: './forms-dialog.component.html',
  styleUrls: ['./forms-dialog.component.scss']
})
export class FormsDialogComponent implements OnInit {
  isReady: boolean = false;

  constructor(private dialog: MatDialogRef<FormsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: TreatmentPlanningFormDataModel) {
    //
  }

  ngOnInit() {
    setTimeout(() => {
      this.isReady = true;
    }, 2000);
  }

  onClose() {
    this.dialog.close();
  }
}
